import $ from 'jquery';

import { showModal } from './b-modal';

var modalTemplate = '\
	<div class="b-modal b-modal_gallery">\
		<div class="b-modal-wrap">\
			<span class="b-modal-close i-modal-close"></span>\
			<div class="b-modal-dialog" id="imgReview">\
				<div class="b-modal-content">\
					<div class="b-modal-body">\
						<div class="b-modal-preview">\
							<img src="">\
						</div>\
					</div>\
				</div>\
			</div>\
		</div>\
	</div>\
';

var modal;
function getModal() {
	if (!modal) {
		var wrap = $('<div>');
		modal = $(modalTemplate).appendTo(wrap);
		wrap.execInit();
		modal.appendTo(document.body);
	}
	return modal;
}

$.addInit(function(context) {
	if (context === document) {
		$(document).on('click', '.i-modal-picture', function(e) {
			e.preventDefault();
			var modal = getModal();

			modal.find('img').prop('src', this.href);
			showModal(modal);
		});
	}
});
